import { api } from "./api";

const SESSION_KEY = "gaole_listing_impressions";
const pending = new Set<string>();
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function sessionSeen(): Set<string> {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

function markSeen(ids: string[]) {
  const seen = sessionSeen();
  for (const id of ids) seen.add(id);
  sessionStorage.setItem(SESSION_KEY, JSON.stringify([...seen].slice(-500)));
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    const batch = [...pending];
    pending.clear();
    if (!batch.length) return;
    void api("/catalog/impressions", { method: "POST", body: { productIds: batch, kind: "LISTING" } }).catch(
      () => {},
    );
  }, 800);
}

/** Count a storefront listing view once per product per browser session. */
export function trackListingImpression(productId: string) {
  if (!productId) return;
  const seen = sessionSeen();
  if (seen.has(productId)) return;
  markSeen([productId]);
  pending.add(productId);
  scheduleFlush();
}
